import { useCallback, useEffect, useState } from 'react';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { getPaymentDistribution } from 'src/shared/services/statisticsService';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { chartHelper } from 'src/shared/helpers/chartHelper';
import { PaymentDistributionResponse } from '../models/paymentDistributionResponse';
import { PaymentDistributionSearchFilter } from '../models/paymentDistributionSearchFilter';

export const useFetchPaymentDistribution = (searchFilter: PaymentDistributionSearchFilter, chartLabel?: string) => {
  const [paymentDistribution, setPaymentDistribution] = useState<PaymentDistributionResponse>();
  const [chartData, setChartData] = useState<(string | number)[][]>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const isMounted = useIsMounted();

  const fetchData = useCallback(async () => {
    setIsLoading(true);
    try {
      const res = await getPaymentDistribution(searchFilter);
      if (isMounted()) {
        ConsoleHelper.log('RES PaymentDistribution', res.data);
        if (res) {
          setPaymentDistribution(res.data);
          setChartData(chartHelper.transformData(res.data.items, chartLabel));
        }
      }
    } catch (error) {
      ConsoleHelper.log(error);
    } finally {
      if (isMounted()) {
        setIsLoading(false);
      }
    }
  }, [isMounted, searchFilter, chartLabel]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { paymentDistribution, isLoading, fetchData, chartData };
};
